export enum FeedbackStyle {
  bottom = 1,
  right
}
